import { createAction } from '@reduxjs/toolkit'
import { UserSettingsState } from './reducers'

export const updateUserSettings =
  createAction<Partial<UserSettingsState>>('updateUserSettings')
